module.exports = __webpack_public_path__ + "static/media/percent-icon.36383b52.svg";